// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GridItemStyle } from "@insite/mobius/GridItem";
import dataTableStyles from "@west/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { recentWishListsStyles } from "@west/Overrides/Widgets/Common/RecentWishLists";
import { color, xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

recentWishListsStyles.wishListCardGridItem = {
    width: 12,
    css: css`
        padding: 0;
    `,
};

recentWishListsStyles.wishListCard = {
    actionAddToCartButton: {
        variant: "primary",
        color: "primary",
        typographyProps: {
            size: 14,
        },
    },
    basicInfoGridItem: {
        width: [12, 12, 5, 5, 5],
        css: css`
            align-items: center;
        `,
    },
    extendedInfoGridItem: {
        width: [12, 12, 7, 7, 7],
        align: "middle",
        css: css`
            align-items: center;
        `,
    },
};

recentWishListsStyles.noWishListsText = {
    ...dataTableStyles.noResultsText,
};

recentWishListsStyles.cardListStyles = {
    gridContainer: {
        gap: 40,
        offsetCss: css`
            &&& {
                width: 100%;
                margin: 0;
            }
        `,
        css: css`
            &&& {
                padding-right: 0;
                padding-left: 0;
            }
        `,
    },
};

recentWishListsStyles.cardContainer = {
    cardDivider: {
        css: css`
            width: 100%;
            margin: 0;
            border-bottom: 1px solid ${color("common.border")};
            &:nth-child(2) > ${GridItemStyle} {
                padding-top: 0;
            }
        `,
    },
    gridItem: {
        width: 12,
        css: css`
            padding: 12px 0;
        `,
    },
};

recentWishListsStyles.noWishListsGridItem = {
    width: 12,
    css: css`
        text-align: center;
        padding: 0;
    `,
};

recentWishListsStyles.noWishListsText = {
    ...dataTableStyles.noResultsText,
};

recentWishListsStyles.titleTypographyStyles = {
    wrapper: {
        css: css`
            border-bottom: 1px solid ${color("common.border")};
            padding-bottom: 12px;
            margin-bottom: 16px;
        `,
    },
    title: {
        variant: "h3",
        size: 20,
    },
};
